<script lang="ts">
    import BarLoader from "svelte-loading-spinners/BarLoader.svelte"
</script>

{#if typeof window !== "undefined"}
    <div style="text-align: center; padding: 40px;">
        <BarLoader />
    </div>
{/if}

<style lang="less">
    div :global {
        div.wrapper {
            margin: 0 auto;
        }
    }
</style>
